import transform from 'lodash-es/transform';

import { PassengerArrangement } from '@shared/base-search-bar/entities/passenger-arrangement';
import { childrenAges, GuestRoom, Guests } from '@shared/base-search-bar/entities/room.entities';

export function multipleTypePassengers(passenger: PassengerArrangement): boolean {
  return passenger?.quantity > 1;
}

export function multipleGuest(guest: Guests): boolean {
  return guest.quantity > 1;
}

export function mapRooms(room: GuestRoom): Guests[] {
  return transform(room, (result, value, key) => {
    (result).push({ quantity: value, id: key });
  }, []).filter(guest => guest.id !== childrenAges);
}
